import { render, staticRenderFns } from "./h5InnerGrowUpList.vue?vue&type=template&id=532271b3&scoped=true"
import script from "./h5InnerGrowUpList.vue?vue&type=script&lang=js"
export * from "./h5InnerGrowUpList.vue?vue&type=script&lang=js"
import style0 from "./h5InnerGrowUpList.vue?vue&type=style&index=0&id=532271b3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "532271b3",
  null
  
)

export default component.exports